import React from 'react';
import WorkerEventDescription from '../components/WorkerEventDescription';
import { formatTimestampISOToBrussels, getTaskType, getDirection, getQueue, getFrom, getTo } from '../helpers/workerEvents';

const inputStyle = { width: '100%', maxWidth: '100%', boxSizing: 'border-box', marginTop: 4 };

export function buildWorkerEventsColumns(uniqueWorkers = []) {
  return [
    {
      key: 'sid', header: 'SID', width: '10%', filterKey: 'sid', accessor: ev => (ev.taskInfo && (ev.taskInfo.taskSid || ev.taskInfo.sid)) || '-',
      filterRender: ({ value, onChange }) => (
        <input style={inputStyle} type="text" value={value} placeholder="Filter" onChange={e => onChange(e.target.value)} />
      )
    },
    {
      key: 'timestamp', header: 'Timestamp', width: '12%', filterKey: 'timestamp', accessor: ev => formatTimestampISOToBrussels(ev.timestamp),
      filterRender: ({ value, onChange }) => (
        <input style={inputStyle} type="text" value={value} placeholder="Filter" onChange={e => onChange(e.target.value)} />
      )
    },
    {
      key: 'eventType', header: 'Event Type', width: '11%', filterKey: 'eventType', render: ev => (
        <span className="badge">{ev.eventType}</span>
      ),
      filterRender: ({ value, onChange }) => (
        <input style={inputStyle} type="text" value={value} placeholder="Filter" onChange={e => onChange(e.target.value)} />
      )
    },
    {
      key: 'worker', header: 'Worker', width: '10%', filterKey: 'worker', accessor: ev => ev.worker,
      filterRender: ({ value, onChange }) => (
        <select style={inputStyle} value={value} onChange={e => onChange(e.target.value)}>
          <option value="">All</option>
          {uniqueWorkers.map(w => <option key={w} value={w}>{w}</option>)}
        </select>
      )
    },
    {
      key: 'description', header: 'Description', width: '22%', filterKey: 'description', render: ev => <WorkerEventDescription ev={ev} />, tdStyle: { whiteSpace: 'normal', lineHeight: 1.25 },
      filterRender: ({ value, onChange }) => (
        <input style={inputStyle} type="text" value={value} placeholder="Filter" onChange={e => onChange(e.target.value)} />
      )
    },
    {
      key: 'type', header: 'Type', width: '8%', filterKey: 'type', accessor: ev => getTaskType(ev),
      filterRender: ({ value, onChange }) => (
        <select style={inputStyle} value={value} onChange={e => onChange(e.target.value)}>
          <option value="">All</option>
          <option value="voice">voice</option>
          <option value="meccatask">meccatask</option>
          <option value="administration">administration</option>
        </select>
      )
    },
    {
      key: 'direction', header: 'Direction', width: '8%', filterKey: 'direction', accessor: ev => getDirection(ev),
      filterRender: ({ value, onChange }) => (
        <input style={inputStyle} type="text" value={value} placeholder="Filter" onChange={e => onChange(e.target.value)} />
      )
    },
    {
      key: 'queue', header: 'Queue', width: '8%', filterKey: 'queue', accessor: ev => getQueue(ev),
      filterRender: ({ value, onChange }) => (
        <input style={inputStyle} type="text" value={value} placeholder="Filter" onChange={e => onChange(e.target.value)} />
      )
    },
    {
      key: 'from', header: 'From', width: '5%', filterKey: 'from', accessor: ev => getFrom(ev),
      filterRender: ({ value, onChange }) => (
        <input style={inputStyle} type="text" value={value} placeholder="Filter" onChange={e => onChange(e.target.value)} />
      )
    },
    {
      key: 'to', header: 'To', width: '6%', filterKey: 'to', accessor: ev => getTo(ev),
      filterRender: ({ value, onChange }) => (
        <input style={inputStyle} type="text" value={value} placeholder="Filter" onChange={e => onChange(e.target.value)} />
      )
    }
  ];
}
